import Api from "~/service/Api";

class AwsS3SignedUrlRepository {
  fetchOne(query) {
    return Api.get("/aws-s3/signed-urls", query);
  }
}

export default AwsS3SignedUrlRepository;
